import React, { useReducer, createContext } from 'react'
import reducer from './reducers'

const initialState = {
  zgsNum: '', // 注释
}

let defaultValue
const context = createContext(defaultValue)

const Provider = props => {
  const [state, originDispatch] = useReducer(reducer, initialState)
  const { children } = props
  const dispatch = action => {
    if (typeof action === 'function') {
      return action(originDispatch)
    }
    return originDispatch(action)
  }
  return (
    <context.Provider value={{ state, dispatch }}>
      { children }
    </context.Provider>
  )
}

export { Provider, context }
